// React
import { useEffect } from 'react';

// Material UI
import { TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';

// Icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Utils
import momentTZ from 'moment-timezone';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { setTimeZone } from '../../../../../../../store/suggestEventSlice';

const TimeZonePicker = () => {
  const theme = createTheme({
    components: {
      MuiTextField: {
        defaultProps: { variant: 'standard' },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            minWidth: '180px',
            padding: '12px 0px 11px 0px',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            cursor: 'pointer',
            textAlign: 'start',
          },
        },
      },
      MuiInput: {
        defaultProps: { disableUnderline: true },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            width: '30px',
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          clearIndicator: {
            padding: '0px',
          },
        },
      },
    },
  });

  const defaultProps = {
    options: momentTZ.tz.names(),
  };

  const timeZone = useSelector((state) => state.suggestEvent.timeZone);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!timeZone || timeZone === '') {dispatch(setTimeZone(momentTZ.tz.guess()));}
  }, [timeZone, dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        {...defaultProps}
        value={timeZone}
        onChange={(e, value) => dispatch(setTimeZone(value))}
        autoComplete
        includeInputInList
        renderInput={(params) => <TextField {...params} margin="normal" size="small" />}
        popupIcon={<ExpandMoreIcon />}
      />
    </ThemeProvider>
  );
};

export default TimeZonePicker;
